<template>
  <div class="homework-report-page">
    <headers :title="title"></headers>
    <section class="rp-time">
      <p>
        {{reportBase.homework_name}}
        <span
          v-if="reportBase.subjective_sum"
          :class="{'active':reportBase.report_status == 3}"
        >{{reportBase.report_status == 2 ? "待批阅":"已批阅"}}</span>
      </p>
      <p v-show="reportBase.subjective_sum && reportBase.report_status == 2">作业含有简答题，该部分需等待老师批阅</p>
      <p>答题用时：{{reportBase.report_time_long | timeMeter(2)}}</p>
      <p>交卷时间：{{reportBase.submit_time | fomartTime('yyyy-MM-dd hh:mm:ss')}}</p>
    </section>
    <section class="rp-statistics">
      <div class="rps-child">
        <div>
          <p>答对</p>
          <p class="green">{{reportBase.right_count}}</p>
        </div>
        <div>
          <p>错误</p>
          <p class="red">{{reportBase.wrong_count}}</p>
        </div>
        <div v-if="reportBase.subjective_sum">
          <p>{{reportBase.report_status == 2 ? "待批阅":"已批阅"}}</p>
          <p
            class="defaul"
          >{{reportBase.report_status == 2 ? reportBase.not_read:reportBase.is_read}}</p>
        </div>
        <div>
          <p>未做</p>
          <p class="defaul">{{reportBase.not_count}}</p>
        </div>
      </div>
      <div class="rps-foot">
        <p>
          得分
          <span>{{reportBase.point}}</span>
        </p>
        <p>
          共
          <span>{{anwser_question.length}}</span> 道题
        </p>
        <p>
          总分
          <span>{{reportBase.score}}</span>
        </p>
      </div>
    </section>
    <section class="rp-remark" v-if="reportBase.report_status == 3">
      <p class="rpr-title">作业总评：</p>
      <p class="rpr-content">{{reportBase.remark ? reportBase.remark: '无'}}</p>
    </section>
    <section class="rp-anwser">
      <div class="rpa-head">
        <p>答题卡</p>
        <p class="notice">
          <i class="green"></i> 答对
        </p>
        <p class="notice">
          <i class="red"></i>答错
        </p>
        <p class="notice" v-if="reportBase.subjective_sum && reportBase.report_status == 2">
          <i class="not-read"></i>待批阅
        </p>
        <p class="notice" v-if="reportBase.subjective_sum && reportBase.report_status == 3">
          <i class="is-read"></i>已批阅
        </p>
        <p class="notice">
          <i class="default"></i>未做
        </p>
      </div>
      <div class="ques-card">
        <section class="sec-info">
          <div>
            <div class="mar20" v-for="(item,index) in anwser_question" :key="index">
              <p
                v-if="item.ques_type != 5"
                class="number"
                :class="item.is_right==1?'true':item.is_right==2?'false':''"
              >{{index+1}}</p>
              <p
                v-else
                class="number"
                :class="!item.user_answer ?'':item.review_status == 1 ? 'is-read':'noRead'"
              >{{index+1}}</p>
            </div>
          </div>
        </section>
      </div>
    </section>
    <van-button class="course-btn" @click="goBack">{{reportBase.report_status == 2?'查看作业':'查看解析'}}</van-button>
  </div>
</template>

<script>
import headers from "@/components/Header";
export default {
  name: "Result",
  components: {
    headers
  },
  data() {
    return {
      title: {
        name: "答题报告"
      },
      reportBase: {},
      detail: {},
      report_id: this.$route.query.id, //报告id
      num: {
        "1": "一",
        "2": "二",
        "3": "三",
        "4": "四",
        "5": "五",
        "6": "六",
        "7": "七"
      },
      anwser_question: []
    };
  },
  computed: {
    text() {
      return parseInt(this.reportBase.point) + "分";
    }
  },
  created() {
    this.getReport();
  },
  methods: {
    getReport() {
      this.$http.get(`/api/app/homework/detail/${this.report_id}`).then(res => {
        res.report_base.right_count = 0;
        res.report_base.wrong_count = 0;
        res.report_base.not_count = 0;
        res.report_base.not_read = 0;
        res.report_base.is_read = 0;
        res.question.forEach(item => {
          if (item.ques_type != 5) {
            if (item.is_right == 1) {
              res.report_base.right_count++;
            } else if (item.is_right == 2) {
              res.report_base.wrong_count++;
            } else {
              res.report_base.not_count++;
            }
          } else {
            if (item.user_answer == "") {
              res.report_base.not_count++;
            } else if (item.review_status == 1) {
              res.report_base.is_read++;
            } else {
              res.report_base.not_read++;
            }
          }
        });
        this.reportBase = res.report_base;
        this.anwser_question = res.question;
      });
    },
    /**
     * 查看解析
     */
    goBack() {
      let query = {
        report_id: this.report_id
      };
      this.$router.push({
        name: "DoHomework",
        query
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.defaults {
  color: #ccc;
}
.homework-report-page {
  @extend %default-bg;
  padding-bottom: 90px;
  .rp-time {
    margin: 20px 30px;
    background: #fff;
    padding: 20px 30px;
    border-radius: 10px;
    p {
      padding: 14px 0 10px 40px;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(89, 89, 89, 1);
      line-height: 40px;
      span {
        display: inline-block;
        border: 1px solid #ee1f1f;
        color: #ee1f1f;
        height: 32px;
        line-height: 32px;
        font-size: 20px;
        padding: 0 4px;
      }
      span.active {
        color: #30b5a6;
        border-color: #30b5a6;
      }
      &:nth-child(1) {
        background: url("~@/assets/images/result-point.png") no-repeat left 20px;
        background-size: 26px 26px;
      }
      &:nth-child(2) {
        color: #b7b7b7;
        font-size: 24px;
        line-height: 40px;
      }
      &:nth-child(3) {
        background: url("~@/assets/images/result-time.png") no-repeat left
          center;
        background-size: 23px 27px;
      }
      &:nth-child(4) {
        background: url("~@/assets/images/result-time-other.png") no-repeat left
          center;
        background-size: 26px 26px;
      }
    }
  }
  .rp-score {
    margin: 0 30px;
    background: #fff;
    padding: 30px;
    border-radius: 10px;
    & > p {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(38, 38, 38, 1);
    }
    .rp-circle {
      width: 204px;
      height: 206px;
      margin: 30px auto;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      p {
        font-family: PingFang SC;
        &:nth-child(1) {
          font-size: 47px;
          font-weight: 500;
          margin-bottom: 6px;
        }
      }
    }
    .rp-circle-pass {
      background: url("~@/assets/images/ques-result-pass.png") no-repeat;
      background-size: 100% 100%;
      p {
        &:nth-child(1) {
          color: rgba(12, 202, 164, 1);
        }
      }
    }
    .rp-circle-fail {
      background: url("~@/assets/images/ques-result-refuse.png") no-repeat;
      background-size: 100% 100%;
      p {
        &:nth-child(1) {
          color: #f65b7a;
        }
      }
    }
    & > div {
      display: flex;
      justify-content: space-between;
      p {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        &:nth-child(1) span {
          color: #ff4157;
          font-size: 28px;
        }
        &:nth-child(2) span {
          color: #0ccaa4;
          font-size: 28px;
        }
      }
    }
  }
  .rp-remark {
    margin: 20px 30px;
    background: #fff;
    border-radius: 10px;
    .rpr-title {
      border-bottom: 1px solid #eaeaea;
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(38, 38, 38, 1);
      line-height: 86px;
      padding: 0 30px;
    }
    .rpr-content {
      font-size: 28px;
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(140, 140, 140, 1);
      line-height: 47px;
      padding: 30px;
    }
  }
  .rp-statistics {
    margin: 20px 30px;
    background: #fff;
    padding: 30px 0;
    border-radius: 10px;
    .rps-child {
      display: flex;
      justify-content: center;
      div {
        padding: 12px 0;
        margin: 0 25px;
        width: 158px;
        height: 81px;
        background: rgba(255, 255, 255, 1);
        border: 1px solid rgba(217, 217, 217, 1);
        border-radius: 10px;
        p {
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: 400;
          color: rgba(140, 140, 140, 1);
          line-height: 40px;
          text-align: center;
        }
        p.green {
          color: #0ccaa4;
          font-size: 30px;
        }
        p.red {
          color: #ff4157;
          font-size: 30px;
        }
        p.defaul {
          color: #b7b7b7;
          font-size: 30px;
        }
      }
    }
    .rps-foot {
      display: flex;
      justify-content: space-between;
      padding: 50px 30px 0 30px;
      p {
        font-size: 24px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(140, 140, 140, 1);
        span {
          color: #ff4157;
          font-size: 28px;
        }
      }
    }
  }
  .rp-anwser {
    margin-top: 30px;
    background: #fff;
    .rpa-head {
      height: 86px;
      border-bottom: 1px solid rgba(234, 234, 234, 1);
      padding: 0 30px;
      line-height: 86px;
      display: flex;
      p {
        display: flex;
        align-items: center;
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        &:nth-child(1) {
          flex: 1;
          color: rgba(38, 38, 38, 1);
        }
      }
      .notice {
        color: #8c8c8c;
        font-size: 24px;
        i {
          display: inline-block;
          width: 24px;
          height: 24px;
          border-radius: 12px;
          margin: 0 10px 0 30px;
        }
        .green {
          background: rgba(12, 202, 164, 1);
        }
        .red {
          background: #ff4157;
        }
        .default {
          border: 1px solid rgba(183, 183, 183, 1);
        }
        .not-read {
          border: 1px solid #ee1f1f;
        }
        .is-read {
          background: #ea7a2f;
        }
      }
    }
    .ques-card {
      padding-bottom: 30px;
    }
    .sec-info {
      & > p {
        font-size: 28px;
        font-family: PingFang SC;
        font-weight: 400;
        color: rgba(89, 89, 89, 1);
        line-height: 40px;
        padding: 20px 20px 0;
      }
      & > div {
        display: flex;
        flex-wrap: wrap;
        div {
          margin-top: 20px;
          width: 20%;
        }
      }
    }
    .number {
      margin: 0 auto;
      width: 54px;
      height: 54px;
      border: 1px solid #eaeaea;
      border-radius: 50%;
      text-align: center;
      font-size: 30px;
      color: #b8b8b8;
      line-height: 54px;
      cursor: pointer;
      flex-shrink: 0;
    }
    .active {
      background-color: $theme_color;
      border: 1px solid $theme_color;
      color: #fff;
    }
    .true {
      background-color: #0ccaa4;
      border: 1px solid #0ccaa4;
      color: #fff;
    }
    .false {
      background-color: #ff4157;
      border: 1px solid #ff4157;
      color: #fff;
    }
    .noRead {
      border-color: #ee1f1f;
      color: #ee1f1f;
    }
    .is-read {
      color: #fff;
      background: #ea7a2f;
      border: 1px solid #ea7a2f;
    }
  }
  .course-btn {
    font-size: 30px;
  }
  .mar20 {
    margin-top: 20px;
  }
}
</style>
